<template>
  <div :class="computedClass">
    <JadeIcon
      v-if="icon"
      :use="icon"
      size="small"
      color="current-color"
    />
    <jade-text
      variant="text-small"
      weight="semibold"
      color="current-color"
    >
      <slot />
    </jade-text>
  </div>
</template>

<script>
import JadeText from '../JadeText/index.vue'
import JadeIcon from '../JadeIcon/index.vue'

import SIZE_ENUM from '../enums/sizes.enum'
import COLOR_ENUM from '../enums/colors.enum'

export default {
  name: 'JadeTag',
  components: {
    JadeText,
    JadeIcon
  },
  props: {
    solid: Boolean,
    icon: String,
    variant: {
      type: String,
      validation: color =>
        Object.values([
          COLOR_ENUM.WARNING,
          COLOR_ENUM.NEGATIVE,
          COLOR_ENUM.POSITIVE,
          COLOR_ENUM.INFO,
          COLOR_ENUM.BRAND,
          COLOR_ENUM.NEUTRAL
        ]).includes(color),
      default: COLOR_ENUM.POSITIVE
    },
    size: {
      type: String,
      validation: size =>
        Object.values([SIZE_ENUM.MEDIUM, SIZE_ENUM.SMALL]).includes(size),
      default: SIZE_ENUM.SMALL
    }
  },

  computed: {
    computedClass () {
      return {
        'jade-tag': true,
        'is-solid': this.solid,
        [`is-${this.size}`]: this.size,
        [`is-${this.variant}`]: this.variant
      }
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/tag.css';
</style>
